import {observer} from 'mobx-react';
import {useMap} from '@vis.gl/react-google-maps';
import {useEffect, useRef} from 'react';

const RadiusCircle = observer(({coords, size}) => {
  const circleRef = useRef(null);
  const map = useMap();

  useEffect(() => {
    if (!coords) {
      removeCircle();
      return;
    }

    circleRef.current ||= new window.google.maps.Circle({
      map,
      clickable: false,
      radius: size,
      fillColor: '#54C379',
      fillOpacity: 0.2,
      strokeColor: '#54C379',
      strokeOpacity: 0.5,
      strokeWeight: 1
    });

    circleRef.current.setCenter(coords);

    return removeCircle;
  }, [coords]);

  function removeCircle() {
    if (!circleRef.current) return;

    circleRef.current.setMap(null);
    circleRef.current = null;
  }

  return null;
});

export default RadiusCircle;
